import React from "react";
import { Logout, SettingsOutlined } from "@mui/icons-material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import WorkspacePremium from "@mui/icons-material/WorkspacePremium";
import { ListItemIcon, Menu } from "@mui/material";
import {
  AccountButtonStyled,
  MenuItemStyled,
} from "@components/MainNavigation/Header/Header.styles";
import { useLogout } from "@hooks/useLogout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { startScreenNavigation } from "@telemetry/navigationTiming";
import { paths } from "@utils/navigation";
import { truncateText } from "@utils/string.ts";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

const AccountMenu: React.FC = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const { logout } = useLogout();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const isAccountMenuOpen = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const isVendorMaster = user?.roles?.includes("vendor-master");
  const handleLicenseClick = async () => {
    startScreenNavigation("Account Menu", window.location.pathname, "Licenses");
    navigate(`${paths.licenses.index}`);
  };
  return (
    <>
      <AccountButtonStyled
        testId="account-button"
        variant="outlined"
        color="inherit"
        startIcon={<AccountCircleOutlinedIcon />}
        endIcon={<KeyboardArrowDownIcon />}
        label={truncateText(user?.name, 25)}
        aria-controls={isAccountMenuOpen ? "account-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={isAccountMenuOpen ? "true" : undefined}
        onClick={handleClick}
      />
      <Menu
        color="inherit"
        anchorEl={anchorEl}
        id="account-menu"
        open={isAccountMenuOpen}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: 240,
              overflow: "visible",
              filter: "drop-shadow(0px 0px 24px rgba(0,0,0,0.04))",
              mt: 0,
            },
          },
          list: {
            sx: {
              padding: "16px",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {isVendorMaster && (
          <MenuItemStyled onClick={handleLicenseClick}>
            <ListItemIcon>
              <WorkspacePremium />
            </ListItemIcon>
            {t("navigation.licenses")}
          </MenuItemStyled>
        )}
        <MenuItemStyled onClick={handleClose}>
          <ListItemIcon>
            <SettingsOutlined color="inherit" />
          </ListItemIcon>
          {t("navigation.settings")}
        </MenuItemStyled>
        <MenuItemStyled
          onClick={() => {
            handleClose();
            window.open("https://drupal-pcs.fujairahport.ae", "_blank", "noopener,noreferrer");
          }}
        >
          <ListItemIcon>
            <HelpOutlineOutlinedIcon color="inherit" />
          </ListItemIcon>
          {t("navigation.help")}
        </MenuItemStyled>
        <MenuItemStyled
          onClick={() => {
            handleClose();
            logout();
          }}
        >
          <ListItemIcon>
            <Logout />
          </ListItemIcon>
          {t("common.logout")}
        </MenuItemStyled>
      </Menu>
    </>
  );
};

export default AccountMenu;
